import { render } from "./Profile.vue?vue&type=template&id=f0156b86"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"
script.render = render

export default script